import {ConsumerAuthenticationInformationSetup} from '@app/model/cyber-source/payer-auth-setup-response';
import {PayerAuthEnrollmentResponse} from '@app/model/cyber-source/payer-auth-enrollment-response';

export enum CyberSourceActionTypes {
  StartPaymentFlow = '[CyberSource] Start CyberSource payment flow',
  PayerAuthSetup = '[CyberSource] Payer auth setup',
  DeviceDataCollection = '[CyberSource] Run device data collection',
  DeviceDataCollectionFinished = '[CyberSource] Finished device data collection',
  PayerAuthEnrollment = '[CyberSource] Payer auth enrollment',
  PaymentSuccess = '[CyberSource] Payment successful',
  PaymentFailure = '[CyberSource] Payment failure',
  Invoke3ds = '[CyberSource] Invoke 3ds',
  Validate3ds = '[CyberSource] Validate 3ds',
  ChallengeFailure = '[CyberSource] 3ds challenge failure',
  GenericError = '[CyberSource] Generic error',
}

export class StartPaymentFlow {
  readonly type = CyberSourceActionTypes.StartPaymentFlow;
}

export class PaymentSuccess {
  readonly type = CyberSourceActionTypes.PaymentSuccess;
  constructor(public data) {
  }
}

export class PaymentFailure {
  readonly type = CyberSourceActionTypes.PaymentFailure;
}

export class PayerAuthSetup {
  readonly type = CyberSourceActionTypes.PayerAuthSetup;
}

export class DeviceDataCollection {
  readonly type = CyberSourceActionTypes.DeviceDataCollection;
  constructor(public authEnrollmentData: ConsumerAuthenticationInformationSetup) {
  }
}

export class DeviceDataCollectionFinished {
  readonly type = CyberSourceActionTypes.DeviceDataCollectionFinished;
  constructor(public referenceId: string) {
  }
}

export class PayerAuthEnrollment {
  readonly type = CyberSourceActionTypes.PayerAuthEnrollment;
  constructor(public referenceId: string = undefined) {
  }
}

export class Invoke3ds {
  readonly type = CyberSourceActionTypes.Invoke3ds;
  constructor(public payerAuthEnrollmentResponse: PayerAuthEnrollmentResponse) {
  }
}

export class Validate3ds {
  readonly type = CyberSourceActionTypes.Validate3ds;
  constructor(public transactionId: string) {
  }
}

export class ChallengeFailure {
  readonly type = CyberSourceActionTypes.ChallengeFailure;
}

export class GenericError {
  readonly type = CyberSourceActionTypes.GenericError
  constructor(public error) {
  }
}

export type CyberSourceActions =
  | StartPaymentFlow
  | PayerAuthSetup
  | DeviceDataCollection
  | DeviceDataCollectionFinished
  | PayerAuthEnrollment
  | Invoke3ds
  | Validate3ds
  | ChallengeFailure
  | PaymentSuccess
  | PaymentFailure
  | GenericError;
